import {USER_TYPES} from "@/constant/Users/types";

export const ACTION_RESET_KYC = "resetKyc";
export const ACTION_RESET_USERNAME = "resetUsername";
export const ACTION_RESET_PASSWORD = "resetPassword";
export const ACTION_DELETE_USER = "deleteUser";
export const ACTION_REMOVE_PERMANENTLY = "removePermanently";
export const ACTION_PROMOTE_TO_PARTNER = "promoteToPartner";
export const ACTION_DEMOTE_FROM_PARTNER = "demoteFromPartner";
export const ACTION_SET_PLATFORM_FEE = "setPlatformFee";

export const WEB_USER_EDIT_ACTIONS = [
  {
    key: ACTION_RESET_KYC,
    title: "Reset Biometric Data",
    variant: "purple",
    description:
      "This will reset the user's KYB / KYC information and send them an automatic email with a link to start a new KYB / KYC process.",
    confirmationText:
      "Are you sure you want to reset the user's biometric data?",
    enable: (userData) => {
      return !!userData?.payment_account;
    },
    endpointPath: "/payment-account",
  },
  {
    key: ACTION_RESET_USERNAME,
    title: "Reset Username",
    variant: "yellow",
    description: `This will reset the user's username and send them an automatic email with a link to reset their username. User status will show as "Reset Username" and user listings and public profile will be paused until username is updated.`,
    confirmationText: "Please enter details to reset the user's username:",
    enable: (userData) => true,
    endpointPath: "/reset-username",
  },
  {
    key: ACTION_RESET_PASSWORD,
    title: "Reset Password",
    variant: "light-green",
    description:
      "This will reset the user password and send them an automatic email with a link to reset their password.",
    confirmationText: "Are you sure you want to reset the user's password?",
    enable: (userData) => true,
    endpointPath: "/reset-password",
  },
  {
    key: ACTION_DELETE_USER,
    title: "Delete User",
    variant: "warning",
    description: `User will not appear in user searches, listings/user profile will be permanently deleted, including all files uploaded. For tax compliance reasons, all user data including personal details, username, address, email, phone, tax ID, transaction history and admin notes will remain stored.`,
    confirmationText: "Are you sure you want to delete this user?",
    enable: (userData) => userData?.status !== "deleted",
    endpointPath: "/delete",
  },
  {
    key: ACTION_REMOVE_PERMANENTLY,
    title: "Remove Permanently",
    variant: "dark-gray",
    description:
      "Compared to deleting a user, all data on file will be permanently deleted (typically used after the tax compliance storage requirement of 10 years has passed). User will not appear under web users any longer, and thus won’t have a status.",
    confirmationText: (
      <>
        <span className="text-danger">
          Warning: this action is irreversible.
        </span>{" "}
        <p>Are you sure you want to remove this user permanently?</p>
      </>
    ),
    enable: (userData) => userData?.status === "deleted",
    endpointPath: "/permanent-delete",
  },
  {
    key: ACTION_PROMOTE_TO_PARTNER,
    title: "Promote to Partner User",
    variant: "pink",
    description:
      "Partners have the added capability to link external videos onto the platform.",
    confirmationText:
      "Are you sure you want to promote this user to a Partner?",
    enable: (userData) => {
      if (!userData?.roles) return false;
      let isPersonal = false;
      let isPartner = false;
      for (const role of userData?.roles) {
        if (role.name === "personal") isPersonal = true;
        if (role.name === "partner") isPartner = true;
      }
      return isPersonal && !isPartner;
    },
    endpointPath: "/promote-partner",
  },
  {
    key: ACTION_DEMOTE_FROM_PARTNER,
    title: "Demote from Partner User",
    variant: "warning",
    description: `This will remove the user's partner status and remove the added capability to link external videos onto the platform.`,
    confirmationText:
      "Are you sure you want to demote this user from a Partner?",
    enable: (userData) => userData?.is_partner === true,
    endpointPath: "/demote-partner",
  },
  {
    key: ACTION_SET_PLATFORM_FEE,
    title: "Set Platform Fee",
    variant: "green",
    description:
      "This will set custom platform fee specific for this user. If not enabled, the default platform fee will be used.",
    confirmationText: "",
    enable: (userData) => {
      if (!userData?.roles) return false;

      return (userData?.roles || []).find((val) => val.name === USER_TYPES.COMMERCIAL);
    },
    endpointPath: "/promote-partner",
  },
];
